import { handleDynamicImportError } from './dynamicImportHandler';

export const setupGlobalErrorHandler = () => {
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;

    if (error && typeof error.message === 'string') {
      const isChunkLoadError =
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Loading chunk') ||
        error.message.includes('ChunkLoadError') ||
        error.name === 'ChunkLoadError';

      if (isChunkLoadError) {
        event.preventDefault();
        handleDynamicImportError(error);
      }
    }
  });

  window.addEventListener('error', (event) => {
    const error = event.error;

    if (error && typeof error.message === 'string') {
      const isChunkLoadError =
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Loading chunk') ||
        error.message.includes('ChunkLoadError') ||
        error.name === 'ChunkLoadError';

      if (isChunkLoadError) {
        event.preventDefault();
        handleDynamicImportError(error);
      }
    }
  });
};
